import axios from 'axios'
import API from './API.js'

export default class Users extends API {
  constructor() {
    super('users')
  }

  async getStatistics(){
    const response = await axios.get('/statistics/general');
    return response.data;
  }

  async students(params = {}) {
    params.with = ['badges']
    params.type = 'student'
    const response = await axios.get(`/${this.route}`, { params })
    console.log('response.data: ', response.data) // data[0].badges
    return response.data
  }

  async teachers(params = {}) {
    params.with = ['badges']
    params.type = 'teacher'
    const response = await axios.get(`/${this.route}`, { params })
    console.log(this.route);
    console.log('response.data: ', response.data) // data[0].badges
    return response.data
  }

  async getTeachers(params = {}) {
    const response = await axios.get('/getTeachers', { params })
    return response.data
  }
  async saveTeachers(data,headers = {}) {
    try {
      const response = await axios.post('/saveStudentMasterTeachers', data, headers)
      return response.data
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response.data;

      }
    }
  }

  async register(data, headers = {}) {
    try {
      const response = await axios.post(`/users-register`, data, headers)
      return response.data
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response.data;

      }
    }
  }
  async reset(data, headers = {}) {
    try {
      const response = await axios.post(`/reset`, data, headers)
      return response.data
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response.data;

      }
    }
  }
  async forgot(params) {
    try {
      const response = await axios.get(`/forgot`, { params })
      return response.data
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response.data;

      }
    }
  }
  async getAllOnline(params) {
    try {
      const response = await axios.get(`/get-all-online`,{ params })
      return response.data
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response;

      }
    }
  }
  async setOnline() {
    try {
      const response = await axios.get(`/setOnline`)
      return response.data
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response.data;

      }
    }
  }

  async sendUserRequest(data, headers = {}) {
    try {
      const response = await axios.post(`/sendUserRequest`, data, headers)
      return response.data
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response.data;

      }
    }
  }
  // 
  async eduProgramUsers(eduProgramId, params = {}) {
    const response = await axios.get(`/eduProgramUsers/${eduProgramId}`, { params })
    console.log(response.data.data);
    let users = [];
    response.data.data.rooms.forEach(room => {
      room.students.forEach(student => {
        users.push(student)
      });
      room.teachers.forEach(student => {
        users.push(student)
      });
    });
    return users
  }

  async getOnlineApplication(params) {
    try {
      const response = await axios.get(`/get-online-application`, { params })
      let { data } = response
      if (params) data = response.data.data
      return response.data
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload 
      }
    }
  }

  async OnlineApplication(id) {
    try {
      const response = await axios.get(`/online-application/${id}`)
      return response.data
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload 
      }
    }
  }
  async sendFile(data, headers = {}) {
    try {
      const response = await axios.post(`/send-file-api`, data, headers)
      return response.data
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response.data;

      }
    }
  }
  async getAllFile(id) {


    const response = await axios.get(`/get-file-api/${id}`)
    return response.data

  }
  async admissionstatus(params) {
     try {
       const response = await axios.get(`/admissionstatus`, { params })

      return response.data
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response.data;

      }
    }
  }
  async enrollmentInfo(params) {
    try {
      const response = await axios.get(`/enrollment-info`, { params })

     return response.data
   } catch (error) {
     if (error.response) {
       // Request made and server responded
       return error.response.data;

     }
   }
 }
  async letterOffer(data, headers = {}) {
    try {
      const response = await axios.post(`/letter-offer`, data, headers)
      return response.data
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response.data;

      }
    }
  }
  ///users/{user}/letter-offer

  async ToggleActivation(user) {
    try {
      const response = await axios.get(`/users/${user}/toggle_activation`);
      return response.data
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response.data;

      }
    }

    
  }
  async getStudentsDataStatics(){
    let res = await axios.get(`/getStudentsDataStatics`);
    return res
  }
  //

  async GetAllTeachersFromQuranShedule(){
    let res = await axios.get(`/GetAllTeachersFromQuranShedule`);
    return res
  }

  async GetAllFilteredByTeacher(params){
    let res = await axios.get(`/GetAllFilteredByTeacher`,{params});
    return res
  }

  async deleteProfile() {
    try {
      const response = await axios.delete(`/profile`)
      return response.data
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  }
}
